export default {
  main: '#214625',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#214625',
  entryBackground: '#214625',
  menuBackgroundColor: '#214625',
  menuTextColor: '#ffffff',
};
